import * as React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { SearchApp } from "../components/search-app";
import {
  renderMenuItem,
  initializeMenuData,
} from "../render-functions/search-render-functions";
import { MenuList } from "././component/menu-list";
import { menuCategoryFactory } from "../factories/menu-factory";
import { Grid } from "@material-ui/core";
import { SearchBar } from "../components/search-bar";
import { DropdownFilter } from "../components/dropdown-filter";
import { resetSearchState } from "../slice/search-slice";

interface Props {
  app: string;
}
export function MenuApp(props: Props) {
  const app = props?.app;
  const dispatch = useDispatch();
  useEffect(() => {
    return function cleanup() {
      dispatch(resetSearchState());
    };
  }, [app]);

  return (
    <SearchApp
      key={app}
      renderSearchList={(renderItem) => {
        return <MenuList renderItem={renderItem} />;
      }}
      renderItem={renderMenuItem}
      initialDataLoad={initializeMenuData}
      categoryFactory={menuCategoryFactory()}
      filters={
        <Grid container>
          <Grid container justifyContent="center" item xs={12} md={6}>
            <DropdownFilter
              categoryName="productType"
              label="Pick something!"
            />
          </Grid>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            item
            xs={12}
            md={6}
          >
            <SearchBar
              label="Search for your favorite!"
              searchPlaceHolder="type to search"
              searchProperties={[
                "searchContent",
                "name",
                "description",
                "groupText",
              ]}
            />
          </Grid>
        </Grid>
      }
    />
  );
}
